import React from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { dateForHumans, formatTimestamp, numberWithCommas } from "../../utils";

function RecentActivity() {
  const url = "api/v2/dashboard/fetch-dashboard";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const columns = [
    {
      title: "Created Date",
      dataIndex: "transTime",
      render: (item) => {
        return <div>{formatTimestamp(item)}</div>;
      },
      sorter: (a, b) => a.transTime - b.transTime,
    }, 
    {
      title: "Amount",
      dataIndex: "transAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.transAmount - b.transAmount,
    },
    {
      title: "TransId",
      dataIndex: "transId",
      sorter: (a, b) => a.transId.localeCompare(b.transId),
    },
    {
      title: "Initiator",
      dataIndex: "kycValue",
      sorter: (a, b) => a.kycValue.localeCompare(b.kycValue),
    },
  ];

  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] ">
      <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS ">
        Recent Activities
      </div>
      <Table
        className="w-full mt-[1.25rem] dash-table"
        scroll={{ x: "auto" }}
        rowKey={(record) => record?.id}
        columns={columns}
        dataSource={data?.recentActivities}
        pagination={false}
      />
    </div>
  );
}

export default RecentActivity;
